<div class="side-bar">
  <div class="d-flex justify-content-between align-items-center pb-px-12">
    <div (click)="onDialogClose()" class="d-flex align-items-center me-2 cursor-pointer">
      <svg-icon (click)="onDialogClose()" src="/assets/icons/arrow-primary-left.svg"></svg-icon><span
        class="fs-16 fw-4 text-accent-action">Retour</span>
    </div>
    <svg-icon (click)="onDialogClose()" src="/assets/icons/close-modal-primary.svg" class="cursor-pointer"></svg-icon>
  </div>
  <mat-tab-group mat-stretch-tabs="{{ false }}" mat-align-tabs="start" color="primary">
    <mat-tab label="Détails">
      <div class="user-container pt-px-24 pb-px-12">
        <img [src]="
            rowData.photo1
              ? 'data:image/jpeg;base64,' + rowData.photo1
              : '/assets/icons/no-pic.svg'
          " alt="user_img" />
        <div>
          <div class="fs-16 fw-7">
            {{
            rowData?.firstname + " " + rowData?.lastname ||
            rowData?.fullname ||
            "N/A"
            }}
          </div>
          <div class="text-accent-action fs-16 fw-4">
            {{ rowData?.mailadress }}
          </div>
          <!-- <app-rating (onClick)="rating($event)" [rating]="4" [readOnly]="true" [width]="14" [height]="14"></app-rating> -->
        </div>
      </div>
      <div class="py-px-12">
        <app-text-separator text="Détails"></app-text-separator>
        <div class="d-flex py-px-12">
          <div class="d-flex flex-column col-6">
            <div class="d-flex flex-column my-px-8">
              <span class="fs-13 fw-3">Téléphone</span>
              <span class="fs-16 fw-4">{{ rowData?.numtel || "N/A" }}</span>
            </div>
            <div class="d-flex flex-column my-px-8">
              <span class="fs-13 fw-3">Fonction</span>
              <span class="fs-16 fw-4">{{
                rowData?.typePosteDto?.name || "N/A"
                }}</span>
            </div>
            <div class="d-flex flex-column my-px-8">
              <span class="fs-13 fw-3">Domaine d’activité</span>
              <span class="fs-16 fw-4">{{
                rowData?.typeSecteur || "N/A"
                }}</span>
            </div>
          </div>
          <div class="d-flex flex-column col-6">
            <div class="d-flex flex-column my-px-8">
              <span class="fs-13 fw-3">Numéro SIRET</span>
              <span class="fs-16 fw-4">{{ rowData?.numsiret || "N/A" }}</span>
            </div>
            <div class="d-flex flex-column my-px-8">
              <span class="fs-13 fw-3">Numéro de sécurité social</span>
              <span class="fs-16 fw-4">{{
                rowData?.numsocialsecurity || "N/A"
                }}</span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <!-- <app-text-separator text="Évaluations et missions"></app-text-separator>
        <div class="d-flex py-px-24">
          <div class="d-flex flex-column col">
            <app-rating (onClick)="rating($event)" [showRateNumber]="true" [rating]="4.7" [readOnly]="true" [width]="14"
              [height]="14"></app-rating>

            <span class="fs-13 fw-3">Évaluation moyenne</span>
          </div>
          <div class="d-flex flex-column col">
            <span class="fs-24 fw-4">33</span>
            <span class="fs-13 fw-3">Total des missions effectuées.</span>
          </div>
          <div class="d-flex flex-column col-5">
            <span class="fs-24 fw-4">12</span>
            <span class="fs-13 fw-3">Collaborations précédentes avec cet établissement.</span>
          </div>
        </div> -->
      </div>
      <div class="d-flex justify-content-between action-buttons">
        <span class="text-secondary fs-16 fw-4">Candidature en cours</span>
        <app-button text="Accepter et générer un contrat" srcIcon="/assets/icons/check-white.svg" color="primary"
          class="me-2"></app-button>
      </div>
    </mat-tab>
    <mat-tab label="Anciennes collaborations">
      <div class="py-px-24">
        <app-text-separator text="candidature En cours"></app-text-separator>
        <div class="my-px-24">
          <div class="card-container p-px-16 mb-px-16">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <svg-icon src="/assets/icons/building-black.svg"></svg-icon>
                <span class="fs-11 fw-7">NovaCare Paris</span>
              </div>
              <app-tag label="Candidature en attente" [type]="0"></app-tag>
            </div>
            <div class="d-flex flex-column">
              <span class="fs-16 fw-4">Mission A</span>
              <span class="text-neutral-dark-grey fs-13 fw-4">du 01 jan 2024 au 15 jan 2024</span>
            </div>
          </div>
        </div>
        <app-text-separator text="Détails"></app-text-separator>
        <div class="my-px-24">
          <div class="card-container p-px-16 mb-px-16">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <svg-icon src="/assets/icons/building-black.svg"></svg-icon>
                <span class="fs-11 fw-7">NovaCare Paris</span>
              </div>
              <app-tag label="Validée" [type]="1"></app-tag>
            </div>
            <div class="d-flex flex-column">
              <span class="fs-16 fw-4">Mission A</span>
              <span class="text-neutral-dark-grey fs-13 fw-4">du 01 jan 2024 au 15 jan 2024</span>
            </div>
          </div>
          <div class="card-container p-px-16 mb-px-16">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <svg-icon src="/assets/icons/building-black.svg"></svg-icon>
                <span class="fs-11 fw-7">NovaCare Paris</span>
              </div>
              <app-tag label="Validée" [type]="1"></app-tag>
            </div>
            <div class="d-flex flex-column">
              <span class="fs-16 fw-4">Mission A</span>
              <span class="text-neutral-dark-grey fs-13 fw-4">du 01 jan 2024 au 15 jan 2024</span>
            </div>
          </div>
          <div class="card-container p-px-16 mb-px-16">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <svg-icon src="/assets/icons/building-black.svg"></svg-icon>
                <span class="fs-11 fw-7">NovaCare Paris</span>
              </div>
              <app-tag label="Validée" [type]="1"></app-tag>
            </div>
            <div class="d-flex flex-column">
              <span class="fs-16 fw-4">Mission A</span>
              <span class="text-neutral-dark-grey fs-13 fw-4">du 01 jan 2024 au 15 jan 2024</span>
            </div>
          </div>
          <div class="card-container p-px-16 mb-px-16">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <svg-icon src="/assets/icons/building-black.svg"></svg-icon>
                <span class="fs-11 fw-7">NovaCare Paris</span>
              </div>
              <app-tag label="Validée" [type]="1"></app-tag>
            </div>
            <div class="d-flex flex-column">
              <span class="fs-16 fw-4">Mission A</span>
              <span class="text-neutral-dark-grey fs-13 fw-4">du 01 jan 2024 au 15 jan 2024</span>
            </div>
          </div>
          <div class="card-container p-px-16 mb-px-16">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <svg-icon src="/assets/icons/building-black.svg"></svg-icon>
                <span class="fs-11 fw-7">NovaCare Paris</span>
              </div>
              <app-tag label="Validée" [type]="1"></app-tag>
            </div>
            <div class="d-flex flex-column">
              <span class="fs-16 fw-4">Mission A</span>
              <span class="text-neutral-dark-grey fs-13 fw-4">du 01 jan 2024 au 15 jan 2024</span>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between action-buttons">
        <span class="text-secondary fs-16 fw-4">Candidature en cours</span>
        <app-button text="Accepter et générer un contrat" srcIcon="/assets/icons/check-white.svg" color="primary"
          class="me-2"></app-button>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>